import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { PromoCodesWrapper } from "../../components";

export default function PromoCodesPage() {
  return (
    <ModalProvider>
      <PromoCodesWrapper />
    </ModalProvider>
  );
}
